/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:22:07
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/swiperIndicator.js
 */
export default {
    // swiperIndicator 组件
    swiperIndicator: {
        length: 0,
        current: 0,
        indicatorActiveColor: '',
        indicatorInactiveColor: '',
		indicatorMode: 'line'
    }
}
